import React from 'react';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import { ExecutiveKPI } from '../utils/executiveMetrics';
type ExecutiveKPICardProps = {
  kpi: ExecutiveKPI;
  variant?: 'hero' | 'secondary';
  gradient?: string;
};
export function ExecutiveKPICard({
  kpi,
  variant = 'hero',
  gradient = 'from-blue-600 to-blue-700'
}: ExecutiveKPICardProps) {
  const isPositiveTrend = kpi.trend >= 0;
  // For time-to-productivity, negative trend is actually good
  const isGoodTrend = kpi.label.includes('Time-to-Productivity') ? kpi.trend < 0 : kpi.trend >= 0;
  if (variant === 'hero') {
    return <div className={`bg-gradient-to-br ${gradient} rounded-2xl p-6 text-white shadow-lg`} data-id="element-25">
        <div className="flex items-start justify-between mb-4" data-id="element-26">
          <p className="text-white/80 font-medium text-sm uppercase tracking-wide" data-id="element-27">
            {kpi.label}
          </p>
          <div className={`
            flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold
            ${isGoodTrend ? 'bg-white/20 text-white' : 'bg-red-400/30 text-red-100'}
          `} data-id="element-28">
            {isPositiveTrend ? <TrendingUpIcon className="w-3 h-3" data-id="element-29" /> : <TrendingDownIcon className="w-3 h-3" data-id="element-30" />}
            <span data-id="element-31">{Math.abs(kpi.trend)}%</span>
          </div>
        </div>

        <p className="text-4xl font-bold mb-2" data-id="element-32">{kpi.value}</p>

        {kpi.subValue && <p className="text-white/70 text-sm" data-id="element-33">{kpi.subValue}</p>}

        <p className="text-white/50 text-xs mt-3" data-id="element-34">{kpi.trendLabel}</p>
      </div>;
  }
  // Secondary variant - smaller, white background
  return <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-200" data-id="element-35">
      <div className="flex items-start justify-between mb-3" data-id="element-36">
        <p className="text-gray-500 font-medium text-sm" data-id="element-37">{kpi.label}</p>
        <div className={`
          flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold
          ${isGoodTrend ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}
        `} data-id="element-38">
          {isPositiveTrend ? <TrendingUpIcon className="w-3 h-3" data-id="element-39" /> : <TrendingDownIcon className="w-3 h-3" data-id="element-40" />}
          <span data-id="element-41">{Math.abs(kpi.trend)}%</span>
        </div>
      </div>

      <p className="text-3xl font-bold text-gray-900 mb-1" data-id="element-42">{kpi.value}</p>

      {kpi.subValue && <p className="text-gray-500 text-sm" data-id="element-43">{kpi.subValue}</p>}
    </div>;
}